import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FooterLinkViewerModels, PageEntityModels } from '@medsurf/flat-models';
import { NavigationControlFacade, NodeSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-chapter',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chapters.component.html',
    styleUrls: ['./chapters.component.scss'],
    standalone: false
})
export class ChaptersComponent {
  /**
   * TODO move to route data
   * Members
   */
  public footerLinks: FooterLinkViewerModels.FooterLink[] = [
    {title: 'DATENSCHUTZERKLÄRUNG', url: 'privacy'},
    {title: 'IMPRESSUM', url: 'impressum'}
  ];

  /**
   * View
   */
  public pageType = PageEntityModels.PageType;

  /**
   * Constructor
   *
   * @param navigationControlFacade
   * @param nodeSharedFacade
   */
  public constructor(public navigationControlFacade: NavigationControlFacade,
                     public nodeSharedFacade: NodeSharedFacade) {
  }
}
